/**
 * Styled Components - Created by cazarez on 07/02/18.
 */
import styled from 'styled-components'
import { GRAY_DISABLE, GRAY_STRONG } from '../../theme/colors'

interface StyledProps {
  width?: string
  verticalAlign?: string
  backgroundColor?: string
  extraCss?: string
  secondary?: boolean
  productDetail?: boolean
}

export const Container = styled.div``

export const Separator = styled.div`
  text-align: center;
  margin-top: ${({ secondary }: StyledProps) => secondary ? '0px' : '30px'};
  margin-bottom: 28px;
  padding: 8px;
  font-family: Avenir;
  background: ${GRAY_DISABLE};
  color: ${GRAY_STRONG};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.93px;
  line-height: 18px;
  width: 100%;
`
export const SlideImage = styled.img`
  width: 100%;
  display: inline-block;
  @media (max-width: 425px) {
    display: none;
  }
`
export const SlideImageMobile = styled.img`
  width: 100%;
  display: none;
  @media (max-width: 425px) {
    display: inline-block;
  }
`
export const SlideVideo = styled.video`
  width: 100%;
  display: inline-block;
  @media (max-width: 485px) {
    display: none;
  }
`
export const SlideVideoMobile = styled.video`
  width: 100%;
  display: none;
  @media (max-width: 485px) {
    display: inline-block;
  }
`
export const ImageContainer = styled.div`
  width: ${({ width }: StyledProps) => width ? width : '100%'};
  text-align: center;
  background: ${({ backgroundColor }: StyledProps) => backgroundColor || 'unset'};
  ${({ verticalAlign }: StyledProps) => verticalAlign ? `
    display: flex;
    align-items: ${verticalAlign};
  ` : ''}
  ${({ extraCss }: StyledProps) => extraCss ? 
    extraCss
  : ''}
`
export const SlideImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`
export const RelatedProductsContainer = styled.div`
  margin-bottom: ${({ productDetail }: StyledProps) => productDetail ? '34px' : '20px'};
  padding: 0px 32px;
`

export const ListContainer = styled.div`
  max-width: 1440px;
  width: 100%;
  margin: 0 auto;
  margin-bottom: -12px;
  padding-right: 26px;
  padding-left: 26px;
  @media (min-width: 320px) and (max-width: 748px) {
    padding-left: 0;
    padding-right: 0;
  }
`

export const StoreLabel = styled.div`
  font-weight: bold;
  text-align: center;
  font-family: Avenir;
  font-size: 16px;
  margin-bottom: -12px;
`

export const DynamicWidth = styled.div`
  width: ${({ width }: StyledProps) => width ? width : '100%'};
  vertical-align: middle;
  display: inline-block;
  @media (max-width: 668px) {
    width: 100%;
  }
  .carouselCmpnt {
    .slick-slide {
      text-align: left;
    }
    .slick-dots{
      bottom: 8px;
    }
    .slick-dots li button {
      height: 0;
    }
    .slick-dots li button:before {
      background: white;
      border-radius: 100px;
      border: 1px solid black;
      box-shadow: 0 0 1px 4px 2px white;
      content: '';
      height: 12px;
      width: 12px;
      margin-top: 4px;
      opacity: 0.8 !important;
    }
    .slick-dots li.slick-active button:before {
      background: black;
      border: 1px solid white;
    }
  }
`

export const ProductContainer = styled.div`
  width: ${({ width }: StyledProps) => width ? width : '100%'} !important;
  position: relative;
  overflow: hidden;
  display: inline-block;
  font-family: Avenir;
  vertical-align: middle;
  .hoverImage {
    display: none !important;
  }
  &:hover {
    .hoverImage { display: block !important; }
    .infoProduct, .hoverControls { display: flex; }
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/YotpoSection/styledComponents.tsx